import * as types from "../types";
import axios from "axios";

axios.defaults.headers.common["Content-Type"] = "application/json";
axios.defaults.headers.common["Authorization"] = "Bearer " + localStorage.token;

const state = {};
const getters = {};
const mutations = {};

const actions = {
  [types.USER_LIST]: ({ commit }, payload) => {
    return new Promise((resolve, reject) => {
      axios
        .get(types.API_BASE_URL + "user/list", payload)
        .then(response => {
          if (response.data.status == 200) {
            resolve(response.data.data);
          } else {
            reject(response.data.messages);
          }
        })
        .catch(error => {
          if (error.response.status == 401) {
            commit(types.MUTATE_LOGOUT);
            reject(error.message);
          } else {
            reject(error.message);
          }
        });
    });
  },
  [types.USER_DETAIL]: ({ commit }, payload) => {
    return new Promise((resolve, reject) => {
      axios
        .get(types.API_BASE_URL + "user/detail/" + payload.params.id, payload)
        .then(response => {
          if (response.data.status == 200) {
            resolve(response.data.data);
          } else {
            reject(response.data.messages);
          }
        })
        .catch(error => {
          if (error.response.status == 401) {
            commit(types.MUTATE_LOGOUT);
            reject(error.message);
          } else {
            reject(error.message);
          }
        });
    });
  },
  [types.USER_CREATE]: ({ commit }, payload) => {
    return new Promise((resolve, reject) => {
      axios
        .post(types.API_BASE_URL + "user/create", payload)
        .then(response => {
          if (response.data.status == 200) {
            resolve(response.data.data);
          } else {
            reject(response.data.messages);
          }
        })
        .catch(error => {
          if (error.response.status == 401) {
            commit(types.MUTATE_LOGOUT);
            reject(error.message);
          } else {
            reject(error.message);
          }
        });
    });
  },
  [types.USER_UPDATE]: ({ commit }, payload) => {
    return new Promise((resolve, reject) => {
      axios
        .post(types.API_BASE_URL + "user/update", payload)
        .then(response => {
          if (response.data.status == 200) {
            resolve(response.data.data);
          } else {
            reject(response.data.messages);
          }
        })
        .catch(error => {
          if (error.response.status == 401) {
            commit(types.MUTATE_LOGOUT);
            reject(error.message);
          } else {
            reject(error.message);
          }
        });
    });
  },
  [types.USER_UPDATE_EMAIL]: ({ commit }, payload) => {
    return new Promise((resolve, reject) => {
      axios
        .post(types.API_BASE_URL + "user/update/email", payload)
        .then(response => {
          if (response.data.status == 200) {
            resolve(response.data.data);
          } else {
            reject(response.data.messages);
          }
        })
        .catch(error => {
          if (error.response.status == 401) {
            commit(types.MUTATE_LOGOUT);
            reject(error.message);
          } else {
            reject(error.message);
          }
        });
    });
  },
  [types.USER_UPDATE_ROLE]: ({ commit }, payload) => {
    return new Promise((resolve, reject) => {
      axios
        .post(types.API_BASE_URL + "user/update/role", payload)
        .then(response => {
          if (response.data.status == 200) {
            resolve(response.data.data);
          } else {
            reject(response.data.messages);
          }
        })
        .catch(error => {
          if (error.response.status == 401) {
            commit(types.MUTATE_LOGOUT);
            reject(error.message);
          } else {
            reject(error.message);
          }
        });
    });
  },
  [types.USER_UPDATE_PASSWORD]: ({ commit }, payload) => {
    return new Promise((resolve, reject) => {
      axios
        .post(types.API_BASE_URL + "user/update/password", payload)
        .then(response => {
          if (response.data.status == 200) {
            resolve(response.data.data);
          } else {
            reject(response.data.messages);
          }
        })
        .catch(error => {
          if (error.response.status == 401) {
            commit(types.MUTATE_LOGOUT);
            reject(error.message);
          } else {
            reject(error.message);
          }
        });
    });
  }
};

export default {
  state,
  mutations,
  actions,
  getters
};
